import { useQuery } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import { GetDisplayPreferenceTemplateQuery } from "~/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetDisplayPreferenceTemplate {
		getDisplayPreferenceTemplate {
			agent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			client {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			supplier {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			receiver {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			product {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			serviceAgent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			serviceClient {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			accountTransaction {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					sections {
						name
						sortingIndex
						display
						rows {
							sortingIndex
							fields {
								sortingIndex
								id
								isVisible
							}
						}
					}
				}
			}
			paymentAttachment {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					sections {
						name
						sortingIndex
						display
						rows {
							sortingIndex
							fields {
								sortingIndex
								id
								isVisible
							}
						}
					}
				}
			}
			file {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					sections {
						name
						sortingIndex
						display
						rows {
							sortingIndex
							fields {
								sortingIndex
								id
								isVisible
							}
						}
					}
				}
			}
		}
	}
`;

export type GetDisplayPreferenceTemplateResults =
	GetDisplayPreferenceTemplateQuery["getDisplayPreferenceTemplate"];

export const getDisplayPreferenceTemplateQueryKey = () => [
	"getDisplayPreferenceTemplate",
];

export const useGetDisplayPreferenceTemplate = (enabled?: boolean) => {
	return useQuery({
		enabled: enabled ?? true,
		queryKey: getDisplayPreferenceTemplateQueryKey(),
		queryFn: async () =>
			apiGqlClient
				.request(graphql(query))
				.then((res) => res.getDisplayPreferenceTemplate),
	});
};

export const useGetDisplayPreferenceTemplateCache = () => {
	return useGetDisplayPreferenceTemplate(false);
};
